<template>
    <div class="section-container">
        <!-- 渲染章节 -->
        <el-collapse-item :name="`module-${item.id}`" :disabled="item.visibility === 'draft'">
            <template #title>
                <div class="module-header">
                    <span class="module-title">{{ item.name }} </span>
                    <span class="module-status"> {{ getCompletedLessons(item) }} / {{ getTotalLessons(item) }}
                    </span>
                    <!-- Complete -->
                </div>
            </template>
            <div class="content-wrapper">
                <!-- 先渲染当前章节的课程，确保每个课程占据一整行 -->
                <div class="lesson-list">
                    <el-button v-for="lesson in item.children.filter(c => c.type === 'lesson')" :key="lesson.id"
                        class="lesson-button" :disabled="lesson.visibility === 'draft'" type="text"
                        @click="$emit('selectLesson', lesson)">
                        <i class="el-icon-video-play"></i>
                        <span class="lesson-text">{{ lesson.name }}</span>
                        <!-- 进度完成时显示对勾 -->
                        <i v-if="isLessonCompleted(lesson.id)" style="margin-left: 15px; color: #10d557;"
                            class="el-icon-circle-check completed-icon"></i>
                    </el-button>
                </div>
                <!-- 再渲染当前章节的子章节 -->
                <section-item v-for="child in item.children.filter(c => c.type === 'section')" :key="child.id"
                    :item="child" :depth="depth + 1" :activeModules="activeModules" :progressData="progressData"
                    @update:activeModules="$emit('update:activeModules', $event)"
                    @selectLesson="$emit('selectLesson', $event)" />
            </div>
        </el-collapse-item>
    </div>
</template>

<script>
export default {
    name: "SectionItem",
    props: ['item', 'depth', 'activeModules', 'progressData'], // 传入进度数据
    methods: {
        getCompletedLessons(section) {
            if (!section.children) return 0;
            return section.children.reduce((count, child) => {
                if (child.type === 'lesson' && this.isLessonCompleted(child.id)) return count + 1;
                if (child.type === 'section') return count + this.getCompletedLessons(child);
                return count;
            }, 0);
        },
        getTotalLessons(section) {
            if (!section.children) return 0;
            return section.children.reduce((count, child) => {
                if (child.type === 'lesson') return count + 1;
                if (child.type === 'section') return count + this.getTotalLessons(child);
                return count;
            }, 0);
        },
        isLessonCompleted(lessonId) {
            // 检查 lesson_id 是否在进度数据中
            console.log(this.item);

            return this.progressData.some(progress => progress.lesson_id === lessonId && progress.progress === 100);
        }
    }
};
</script>

<style scoped>
.section-container {
    padding-left: 10px;
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* 课程列表 */
.lesson-list {
    display: block;
    /* 确保课程独占一行 */
    padding-left: 10px;
}

/* 课程按钮 */
.lesson-button {
    display: flex;
    align-items: center;
    width: 100%;
    /* 让每个按钮独占一整行 */
    text-align: left;
    /* color: #409EFF; */
    background: transparent;
    border: none;
    font-size: 14px;
    padding: 10px;
    border-bottom: 1px solid #ddd;
}

.lesson-button i {
    margin-right: 5px;
}

.lesson-button:hover {
    background-color: #ecf5ff;
    border-radius: 4px;
}

.el-button {
    margin-left: 0px;
}

.module-status {
    color: #409EFF;
}

.module-heade {}
</style>